<template>
    <div class="section-box">
        <el-tabs v-model="form.status" type="card" class="customer-tabs-mg" @tab-click="handleSearch()">
            <el-tab-pane v-for="(item, index) in tabList" :label="item.value" :name="item.key + ''" :key="index+''">
            </el-tab-pane>
        </el-tabs>
        <div class="customer-list-serviceType">
            <div class="next-button">
                <el-button size="small" type="primary" icon="el-icon-plus" plain @click="openStageModl()">新增</el-button>
                <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="small" type="success" @click="handleReset">重置</el-button>
            </div>
        </div>
        <!-- eslint-disable  -->
        <el-table
                ref='table'
                :stripe="true"
                :data="tableData"
                style="width: 100%"
                height="670"
                border
                v-loading="listLoading"
                :key="toggleIndex"
        >
            <el-table-column label="服务类型编号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input type="number" size="mini" v-model="form.id" placeholder="请输入编号搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.id || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所属领域">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.domainName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.domainName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所属一级产品">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.firstProductName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.firstProductName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="服务类型名称">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.serviceStageName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.serviceStageName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" fixed="right"  width="200">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" v-if="!scope.row.status" @click="confirmZF(true,scope.row.id)">恢复</el-button>
                    <el-button size="mini" type="warning" v-if="scope.row.status" @click="openZFModel(scope.row)">作废</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="form.pageNum"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="form.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <add-stage
                ref="addSerial"
                v-if="showStage"
                :title="'新增服务类型'"
                @close="closeStage"
                @refreshList="successStage">
        </add-stage>
        <el-dialog
                title="作废操作"
                :visible="showZFModel"
                :close-on-click-modal="!showZFModel"
                :before-close="closeZFModel"
                width="500px"
        >
            <div class="pad-20">
                <h3>您正在执行作废操作，一旦确认，服务类型【{{zfname}}】和对应的Offer将被作废，请谨慎操作</h3>
                <div class="dialog-footer" style="text-align: center;margin-top: 40px;" slot="footer">
                    <el-button type="primary" @click="confirmZF(false,-2)">确认作废</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getStageList,updateStage} from "@/service/dataFrame";
    import addStage from './index/addStage';
    import { getStorageUserRoleId,getActionData } from '@/utils/store'
    export default {
        name: "serviceTypelibrary",
        components:{addStage},
        data(){
            return{
                tableData:[],
                listLoading:false,
                form:{
                    id:'',
                    serviceStageName:'',
                    domainName:'',
                    firstProductName:'',
                    status:'1',
                    pageNum: 1,
                    pageSize: 10
                },
                total: 0,
                searchData:{},
                toggleIndex:0,
                tabList:[
                    {key:'1',value:'有效服务类型'},
                    {key:'0',value:'无效服务类型'},
                ],
                oraginForm:{},
                showStage:false,
                showZFModel:false,//作废
                zfname:'',
                zfModl:{}
            }
        },
        activated(){
            this.handleSearch()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            this.handleSearch()
        },
        methods:{
            handleSearch(){
                this.searchData = Object.assign({}, this.form)
                this.form.pageNum = 1;
                this.searchData.pageNum = 1;
                this.getServTypelist();
            },
            async getServTypelist(){
                this.listLoading = true;
                this.toggleIndex=this.form.status;
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.id && delete data.id
                !data.serviceStageName && delete data.serviceStageName
                !data.domainName && delete data.domainName
                !data.firstProductName  && delete data.firstProductName
                data.status=this.form.status==1?true:false
                let res = await getStageList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.datas || [];
                this.total = res.Data.total;
                this.$nextTick(() => {
                    this.$refs.table.bodyWrapper.scrollTop = 0
                    this.$refs.table.doLayout()
                })
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val;
                this.searchData.pageNum = 1
                this.searchData.pageSize = val;
                this.getServTypelist();
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val;
                this.searchData.pageNum = val;
                this.getServTypelist();
            },
            openZFModel(data){
                this.showZFModel=true;
                this.zfname=data.serviceStageName;
                this.zfModl={
                    id:data.id,
                }
            },
            confirmZF(data,id){
                let param={
                    status:data,
                    userId:getStorageUserRoleId()
                }
                if(id>-1){
                    param.id=id
                }else{
                    param.id=this.zfModl.id
                }
                updateStage(param).then((res)=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.showZFModel=false;
                    this.$message.success("操作成功")
                    if(data){
                        this.form.status = '1';
                    }else{
                        this.form.status = '0';
                    }
                    this.getServTypelist();
                })
                console.log("作废")
            },
            closeZFModel(){
                this.showZFModel=false;
            },
            successStage(){
                this.getServTypelist();
            },
            openStageModl(){
                this.showStage=true;
            },
            closeStage(){
                this.showStage=false;
            },
            // 重置
            handleReset() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
        }
    }
</script>

<style lang="scss">
    .customer-list-serviceType{
        position: relative;

        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }
</style>
